import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-suc",
  "use": "icon-suc-usage",
  "viewBox": "0 0 42 42",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 42 42\" id=\"icon-suc\">\n  <g id=\"icon-suc_提交成功\" transform=\"translate(-86.729 -29)\">\n    <circle id=\"icon-suc_Ellipse\" cx=\"21\" cy=\"21\" r=\"21\" transform=\"translate(86.729 29)\" fill=\"#2dcc2c\" />\n    <path id=\"icon-suc_路径_294\" data-name=\"路径 294\" d=\"M1187.471,718.242l5.394,5.325,9.263-9.252\" transform=\"translate(-1087.271 -669)\" fill=\"none\" stroke=\"#fff\" stroke-width=\"2\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol